export default __webpack_public_path__ + "static/Tip-3-Book-red-eye-flights-67d513c24eda53e41fbf182ef6adb3f5.jpg";